import React, { Component } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import apiError from '../../error';
import axios from '../../axios';
import { PiCopy } from 'react-icons/pi';
import { LensTwoTone } from '@material-ui/icons';
export default class CopyIntegrationApiToken extends Component {
    constructor(props) {
        super(props);
    }

    handleCopyToClipboard = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            toast.success("Copied to clipboard");
        }).catch(err => {
            apiError(err);
        });
    }


    render() {
        return (
            <Modal show={this.props.showModal}>
                <Modal.Header>
                    <Modal.Title id="example-custom-modal-styling-title">
                        <h5>Copy API Token</h5>
                        <p>Securely copy your token before closing</p>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="noteSection mt-0">
                        <p><b>Note:</b> Copy your API token and store it in a safe place. You won’t be able to retrieve it after completing this step. </p>
                    </div>
                    <div>
                        <Form.Label>Token</Form.Label>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Form.Control type="text" placeholder="Enter name here" value={this.props.apiKey} disabled={true} />
                            <div className="copyIcon2" onClick={() => {this.handleCopyToClipboard(this.props.apiKey)}
}>
                                <PiCopy></PiCopy>
                            </div>

                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button className='btn btn-success' onClick={this.props.hideModal}>Done</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}